import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class Application_FormProvider {
  form: FormGroup;
  formstep2: FormGroup;

  constructor(private fb: FormBuilder) {}

  initFormStep1(): FormGroup {
    return (this.form = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      roleName: [null],
      email: ['', [Validators.required, Validators.email]],
      organisation: ['', [Validators.required]],
      tradingAs: [''],
      type: [''],
      phoneCountryCode: [null],
      phoneAreaCode: [null],
      phoneNumber: [null],
      mobileCountryCode: [null],
      mobileAreaCode: [null],
      mobileNumber: [null, [Validators.required]],
      mobile: [null],
      directDial: [null],
      address1: ['', [Validators.required]],
      address2: [''],
      area: [''],
      city: [null, [Validators.required]],
      state: [null],
      postCode: [''],
      country: [null, [Validators.required]],
    }));
  }

  initFormStep2(): FormGroup {
    return (this.formstep2 = this.fb.group({
      bankId: [null],
      bankName: [''],
      accountNumber: [''],
      sortCode: [''],
      swiftBic: [''],
      iban: [''],
      addressProofFile: [null, [Validators.required]],
      bankStatementFile: [null],
      idProofFile: [null, [Validators.required]],
    }));
  }
}
